import React from 'react';

const examSchedule = [
  { id: 1, title: "第1回", examDate: "2026-01-17", appPeriod: "1月5日(月)～1月16日(金)", displayDate: "1 月 17 日(土)" },
  { id: 2, title: "第2回", examDate: "2026-02-14", appPeriod: "2月2日(月)～2月13日(金)", displayDate: "2 月 14 日(土)" },
  { id: 3, title: "第3回", examDate: "2026-02-28", appPeriod: "2月16日(月)～2月27日(金)", displayDate: "2 月 28 日(土)" },
  { id: 4, title: "第4回", examDate: "2026-03-14", appPeriod: "3月2日(月)～3月13日(金)", displayDate: "3 月 14 日(土)" },
  { id: 5, title: "第5回", examDate: "2026-03-21", appPeriod: "3月16日(月)～3月19日(木)", displayDate: "3 月 21 日(土)" },
  { id: 6, title: "第6回", examDate: "2026-03-28", appPeriod: "3月23日(月)～3月27日(金)", displayDate: "3 月 28 日(土)" },
];

const EntranceExamInfo = () => {
  // 現在の日付を取得
  const now = new Date();
  const currentEvent = examSchedule.find(event => {
    const examDateEnd = new Date(`${event.examDate}T23:59:59`);
    return examDateEnd >= now;
  });

  if (!currentEvent) return null;

  return (
    <div className="bg-white p-6 md:p-10 rounded-lg shadow-lg mb-8 border-t-4 ">
      <div className="mt-6 text-lg w-fit mx-auto text-left">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-red-900 tracking-widest mb-5">
          {currentEvent.title} 2026年度生 入学試験
        </h2>

        <p className="font-semibold mt-4 text-xl">
          選考日:<span className='md:text-4xl text-2xl ml-2'> {currentEvent.displayDate}</span>
        </p>

        <p className="font-semibold mt-4 text-gray-700">
          出願期間: {currentEvent.appPeriod}
        </p>
      </div>
    </div>
  );
};

export default EntranceExamInfo;